import React, { VFC } from 'react';
import { css } from '@emotion/css';
import p5Img from '../../assets/images/p5.jpg';

export const P5Section: VFC = () => {
  return (
    <section className={styles.wrapper} aria-label="P5">
      <h2 className={styles.title}>我们的专业基因</h2>
      {/* <p className={styles.desc}>
        这是副标题文案这是副标题文案这是副标题文案这是副标题文案
      </p> */}
      <div className={styles.row}>
        <div className={styles.left}>
          <h3 className={styles.leftTitle}>我们是懂 AI，更懂业务的专家</h3>
          <p className={styles.p}>
						我们的使命是作为您的“业务伙伴”，将AI的变革力真正注入您的企业。
          </p>
          <p className={styles.p}>
					公司聚焦智能体开发、AI 视觉及计算机视觉技术等AI技术核心领域，凭借深厚的技术积淀与行业洞察力，成功打造了一系列全案效能提升标杆项目，为客户提供高效精准、兼具创新性的技术服务与解决方案。
          </p>
          <p className={styles.p}>
          秉持 “技术创新与商业价值共生” 的发展理念，公司持续探索人工智能技术的前沿应用场景，基于对市场需求的深刻理解，不断拓展业务边界与服务维度。
          </p>
					<p className={styles.p}>
          通过提供高品质、定制化的智能化解决方案，助力企业加速数字化转型进程，构建可持续的长期竞争优势。
          </p>
        </div>
        <div className={styles.right}>
          <img src={p5Img} alt="我们的专业基因" className={styles.image} />
        </div>
      </div>
    </section>
  );
};

const styles = {
  wrapper: css`
    pointer-events: none;
    position: relative;
    min-height: calc(var(--vh, 1vh) * 100);
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 6vh 0;
    width: min(1400px, 92vw);
    color: #fff;
  `,
  title: css`
    pointer-events: auto;
    text-align: center;
    font-size: 42px;
    font-weight: 800;
    margin: 0 0 5px 0;
    opacity: 0;
    transform: translate3d(30px, 0, 0);
    transition: opacity 0.7s ease, transform 0.7s ease;
    .reveal-visible & {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
    
    @media (max-width: 768px) {
      font-size: 32px;
    }
  `,
  desc: css`
    pointer-events: auto;
    text-align: center;
    margin: 0 auto;
    max-width: 760px;
    font-size: 20px;
    opacity: 0;
    transform: translate3d(-30px, 0, 0);
    transition: opacity 0.7s ease, transform 0.7s ease;
    .reveal-visible & {
      opacity: 0.9;
      transform: translate3d(0, 0, 0);
    }
  `,
  row: css`
    pointer-events: auto;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 18px;
    align-items: stretch;
    opacity: 0;
    transition: opacity 0.7s ease 0.1s;
		background: '#fff';
		margin-top: 40px;

    .reveal-visible & {
      opacity: 1;
    }

    @media (max-width: 980px) {
      grid-template-columns: 1fr;
    }
  `,
  left: css`
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 14px;
    padding: 26px;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.25);
    backdrop-filter: blur(6px);
    color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
  `,
  leftTitle: css`
    margin: 0 0 12px 0;
    font-size: 20px;
    font-weight: 700;
  `,
  p: css`
    margin: 10px 0;
    opacity: 0.9;
    line-height: 2;
    font-size: 16px;
  `,
  right: css`
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 14px;
    background: rgba(0, 0, 0, 0.25);
    backdrop-filter: blur(6px);
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
    overflow: hidden;
  `,
  image: css`
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  `,
};
